// feature/insumos-mega — admin/directora reassigns an insumos case to another team member.
// Calls POST /api/cases/:id/reassign-insumo (feature/insumos-auto-assignment endpoint).
import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import Spinner from "./Spinner";
import { useToast } from "./Toast";
import { users as usersApi, cases as casesApi } from "../api/endpoints";

export default function ReassignModal({ caseId, caseNumber, currentUserId, onClose, onSuccess }) {
  const toast = useToast();
  const [team, setTeam] = useState(null);
  const [targetId, setTargetId] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    usersApi.withRoles().then(r => {
      const arr = (r.data || []).filter(u =>
        (u.roles || []).includes("insumos") || u.role === "insumos"
      );
      setTeam(arr);
      const first = arr.find(u => u.id !== currentUserId && u.available_for_assignment !== false);
      if (first) setTargetId(String(first.id));
    }).catch(() => setTeam([]));
  }, [currentUserId]);

  async function confirm() {
    if (!targetId) return;
    setBusy(true);
    try {
      await casesApi.reassignInsumo(caseId, Number(targetId));
      toast.push(`Caso ${caseNumber} reasignado correctamente`);
      onSuccess?.();
    } catch (e) {
      toast.push(e?.response?.data?.error || "Error al reasignar", "error");
    } finally { setBusy(false); }
  }

  const otherInsumos = (team || []).filter(u => u.id !== currentUserId);

  return (
    <Modal
      open
      title={`Reasignar caso ${caseNumber}`}
      onClose={busy ? undefined : onClose}
      footer={<>
        <button className="secondary" disabled={busy} onClick={onClose}>Cancelar</button>
        <button disabled={busy || !targetId || otherInsumos.length === 0} onClick={confirm}>
          {busy && <Spinner color="currentColor" />} Confirmar reasignación
        </button>
      </>}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div>
          <label>Reasignar a</label>
          {team == null ? <Spinner /> : otherInsumos.length === 0 ? (
            <div className="muted" style={{ fontSize: 13 }}>
              No hay otros usuarios de insumos disponibles.
            </div>
          ) : (
            <select value={targetId} onChange={(e) => setTargetId(e.target.value)} disabled={busy}>
              {otherInsumos.map(u => (
                <option key={u.id} value={u.id}>
                  {u.name || u.email}
                  {u.cases_assigned_today_actual != null && u.daily_quota != null
                    ? ` (${u.cases_assigned_today_actual}/${u.daily_quota} hoy)` : ""}
                  {u.available_for_assignment === false ? " — no disponible" : ""}
                </option>
              ))}
            </select>
          )}
        </div>
        <div>
          <label>Motivo (opcional)</label>
          <textarea value={reason} onChange={(e) => setReason(e.target.value)} disabled={busy}
                    placeholder="Ej: especialista en este tipo de caso, cambio de carga…" />
        </div>
      </div>
    </Modal>
  );
}
